<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><b>Contents</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="20%"/>
<col width="80%"/>
</colgroup>
<tbody>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc1a"><a href="#/xhtml/06_Acknowledgements"><i>Acknowledgements</i></a></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc1a"><a href="#/xhtml/07_List_of_Abbreviations"><i>List of Abbreviations</i></a></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc1a"><a href="#/xhtml/08_Foreword"><i>Foreword</i></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/10_Chapter01"><b>Chapter 1</b></a></p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/10_Chapter01">General Sir Ian Hamilton and the British Army, 1853–1915</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample"><b>Chapter 2</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample">Why Gallipoli?</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample"><b>Chapter 3</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">A Badly Launched Operation</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample"><b>Chapter 4</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">Fighting and Command</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample"><b>Chapter 5</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">Command and Politics</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample"><b>Chapter 6</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">Fighting and the Truth</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample"><b>Chapter 7</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">An Unfair Withdrawal?</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample"><b>Chapter 8</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">Conclusion</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc1"><span href="#/xhtml/18_Notes" title="Link target outside of Sample"><i>Notes</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc1a"><span href="#/xhtml/19_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?0de45b11